<template>
  <div class="content" @scroll="scrollEven">
    <div class="banner">
      <div class="banner-text">
        <h3 id="bannerH">{{ $t("contacttab") }}</h3>
        <span>{{ $t("aboutus.titleSecondaryTitleB") }}</span>
      </div>
      <img
        src="http://imarshi-web.oss-cn-shanghai.aliyuncs.com/image/contact-banner2.png"
      />
    </div>
    <div class="contact1-content">
      <div class="contact1-left">
        <h3 class="fadeIn">{{ $t("contact.title") }}</h3>
        <p class="fadeIn">{{ $t("contact.titleSecondaryTitle") }}</p>
        <label class="Cmove1"
          >{{ $t("transparency") }} – {{ $t("standardization") }} –
          {{ $t("informatization") }}
        </label>
        <router-link to="/aboutUs">
          <!-- <div
            class="contact1-button Cmove2"
            @mouseover="mouseoverB"
            @mouseleave="mouseleaveB"
          >
            {{ $t("aboutUs") }}<img :src="go" />
          </div> -->
          <button
            class="contact1-button Cmove2"
            @mouseover="mouseoverB"
            @mouseleave="mouseleaveB"
          >
            {{ $t("aboutUs") }}<img :src="go" />
          </button>
        </router-link>
      </div>
      <div class="contact1-right">
        <img
          src="http://imarshi-web.oss-cn-shanghai.aliyuncs.com/image/contentP-11.png"
          class="con-img fromTop"
        />
        <!-- <div class="contact1-form">
          <h3>Enquire Now</h3>
          <el-form label-position="left" label-width="80px" :model="formData">
            <el-form-item label="Name">
              <el-input
                v-model="formData.name"
                placeholder="Please Enter Name"
              ></el-input>
            </el-form-item>
            <el-form-item label="Phone">
              <el-input
                v-model="formData.phone"
                placeholder="Please Enter Phone"
              ></el-input>
            </el-form-item>
            <el-form-item label="Email">
              <el-input
                v-model="formData.email"
                placeholder="Please Enter Email"
              ></el-input>
            </el-form-item>
            <el-form-item label="Message">
              <el-input
                v-model="formData.message"
                type="textarea"
                :rows="6"
                placeholder="Please Enter Message"
              ></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="onSubmit">Send</el-button>
            </el-form-item>
          </el-form>
        </div> -->
      </div>
    </div>
    <div class="contact2-content">
      <div class="map">
        <div class="red-point area1"></div>

        <div class="red-point area2"></div>

        <div class="red-point area3"></div>

        <div class="red-point area4"></div>

        <img
          src="http://imarshi-web.oss-cn-shanghai.aliyuncs.com/image/map.png"
        />
      </div>
      <div class="where">
        <h3 class="Cmove3">{{ $t("contact.title1") }}</h3>
        <p class="Cmove4">{{ $t("contact.titleSecondaryTitle1") }}</p>
      </div>
    </div>
    <div class="contact3-content">
      <div class="content-top Cmove5">
        <div>{{ $t("ingapore") }}</div>
        <div>{{ $t("china") }}</div>
        <div>{{ $t("greece") }}</div>
      </div>
      <div class="content-bottom">
        <div class="second">
          <div class="card Cmove6">
            <h1>{{ $t("contact.title2") }}</h1>
            <p>{{ $t("contact.addess1") }}</p>
            <p>{{ $t("tel") }}： +65-6281 8608 / +65-9234 5587</p>
            <p>{{ $t("email") }}： sales-sg@emsolmarine.com</p>
          </div>
        </div>
        <div class="second">
          <div class="card Cmove61">
            <h1>{{ $t("contact.title3") }}</h1>
            <p>
              {{ $t("contact.addess2") }}
            </p>
            <p>{{ $t("tel") }}： +86 513 83500299</p>
            <p>{{ $t("email") }}： sales-cn@emsolmarine.com</p>
          </div>
          <div class="card Cmove7">
            <h1>{{ $t("contact.title4") }}</h1>
            <p>
              {{ $t("contact.addess3") }}
            </p>
            <p>{{ $t("tel") }}： +86 580 2380101</p>
            <p>{{ $t("email") }}： sales-cn@emsolmarine.comm</p>
          </div>

          <div class="card Cmove8">
            <h1>{{ $t("contact.title5") }}</h1>
            <p>
              {{ $t("contact.addess4") }}
            </p>
            <p>{{ $t("tel") }}： +86 518 82306916</p>
            <p>{{ $t("email") }}： sales-cn@emsolmarine.com</p>
          </div>
        </div>
        <div class="second">
          <div class="card Cmove62">
            <h1>{{ $t("contact.title6") }}</h1>
            <p>{{ $t("name") }}： Ms. Alina Soutsiou</p>
            <p>{{ $t("tel") }}： +306945995699</p>
            <p>{{ $t("email") }}： greece@emsolmarine.com</p>
          </div>
        </div>
      </div>
    </div>
    <footer class="app-footer">
      © 2022 Emsol Maine Service Pte Ltd. All Right Reserved.
    </footer>
  </div>
</template>
<script>
import contactBanner from "../assets/img/contact-banner.png";
import go from "../assets/img/go.png";
import contentP1 from "../assets/img/contentP-1.png";
import map from "../assets/img/map.png";
import goWhite from "../assets/img/go-white.png";
export default {
  name: "app-contact",
  data() {
    return {
      contactBanner,
      go,
      map,
      goWhite,
      contentP1,
      formData: {
        name: "",
        phone: "",
        email: "",
        message: "",
      },
    };
  },
  methods: {
    mouseoverB(e) {
      e.target.firstElementChild.src = this.goWhite;
    },
    mouseleaveB(e) {
      e.target.firstElementChild.src = this.go;
    },
    scrollEven(e) {
      let { scrollTop } = e.target;
      let realHeight =
        document.getElementsByClassName("content")[0].clientHeight +
        scrollTop +
        20;
      let Cmove1 = document.getElementsByClassName("Cmove1")[0];
      let Cmove2 = document.getElementsByClassName("Cmove2")[0];
      let Cmove3 = document.getElementsByClassName("Cmove3")[0];
      let Cmove4 = document.getElementsByClassName("Cmove4")[0];
      let Cmove5 = document.getElementsByClassName("Cmove5")[0];
      let Cmove6 = document.getElementsByClassName("Cmove6")[0];
      let Cmove61 = document.getElementsByClassName("Cmove61")[0];
      let Cmove62 = document.getElementsByClassName("Cmove62")[0];
      let Cmove7 = document.getElementsByClassName("Cmove7")[0];
      let Cmove8 = document.getElementsByClassName("Cmove8")[0];
      if (realHeight > Cmove1.offsetTop) {
        Cmove1.classList.add("fadeIn");
      }
      if (realHeight > Cmove2.offsetTop) {
        Cmove2.classList.add("fadeIn");
      }
      if (realHeight > Cmove3.offsetTop) {
        Cmove3.classList.add("fadeIn");
      }
      if (realHeight > Cmove4.offsetTop) {
        Cmove4.classList.add("fadeIn");
      }
      if (realHeight > Cmove5.offsetTop) {
        Cmove5.classList.add("fadeIn");
      }
      if (realHeight > Cmove6.offsetTop) {
        Cmove6.classList.add("fadeIn");
        Cmove61.classList.add("fadeIn");
        Cmove62.classList.add("fadeIn");
      }
      if (realHeight > Cmove7.offsetTop) {
        Cmove7.classList.add("fadeIn");
      }
      if (realHeight > Cmove8.offsetTop) {
        Cmove8.classList.add("fadeIn");
      }
    },
    onSubmit() {},
  },
};
</script>

<style scoped lang="less">
.content {
  display: flex;
  flex-direction: column;
  overflow-x: hidden;
  height: calc(100vh - 80px);
  margin-top: 80px;
  overflow-y: scroll;
  a {
    text-decoration: none;
  }
  .banner {
    width: 100%;
    height: 560px;
    position: relative;
    .banner-text {
      position: absolute;
      text-align: center;
      height: 128px;
      top: calc(50% - 64px);
      left: calc(50% - 178px);
      h3 {
        font-size: 40px;
        font-family: Microsoft YaHei UI-Bold, Microsoft YaHei UI;
        font-weight: bold;
        color: #ffffff;
        margin: 17px auto;
      }
      span {
        font-size: 16px;
        font-family: Microsoft YaHei UI-Regular, Microsoft YaHei UI;
        font-weight: 400;
        color: #ffffff;
        line-height: 30px;
      }
      #bannerH {
        -webkit-animation: bannerH1 0.6s 0.2s ease both;
        -moz-animation: bannerH1 0.6s 0.2s ease both;
      }
      @-webkit-keyframes bannerH1 {
        0% {
          opacity: 0;
          -webkit-transform: translateX(200px);
        }
        100% {
          opacity: 1;
          -webkit-transform: translateX(0);
        }
      }
      @-moz-keyframes bannerH1 {
        0% {
          opacity: 0;
          -moz-transform: translateX(200px);
        }
        100% {
          opacity: 1;
          -moz-transform: translateX(0);
        }
      }
    }
    img {
      width: 100%;
      height: 100%;
    }
  }
  .contact1-content {
    margin: 0 auto;
    width: 1440px;
    text-align: left;
    justify-content: space-between;
    display: flex;
    margin-bottom: 120px;
    .contact1-left {
      padding-top: 127px;
      width: calc(50% - 130px);
      .Cmove1 {
        opacity: 0;
      }
      .Cmove1 {
        opacity: 0;
      }
      h3 {
        font-size: 40px;
        opacity: 0;
        font-family: Arial-Bold, Arial;
        font-weight: bold;
        color: #2a2e2e;
        margin-top: 0;
        padding-bottom: 40px;
        margin-bottom: 36px;
        border-bottom: 1px solid #dee0e3;
      }
      p {
        font-size: 16px;
        opacity: 0;
        font-family: Arial-Bold, Arial;
        font-weight: 400;
        color: #2a2e2e;
        line-height: 30px;
        margin-bottom: 34px;
      }
      label {
        font-size: 18px;
        font-family: Arial-Bold, Arial;
        font-weight: bold;
        color: #2a358e;
      }
      .contact1-button {
        margin-top: 140px;
        background-color: #fff;
        opacity: 0;
        cursor: pointer;
        padding: 9px 22px 9px 22px;
        border-radius: 4px 4px 4px 4px;
        display: flex;
        align-items: center;
        border: 2px solid #2a358e;
        font-size: 16px;
        font-family: Arial-Regular, Arial;
        font-weight: 400;
        color: #2a358e;
        background-clip: text;
        img {
          width: 16px;
          height: 16px;
          margin-left: 22px;
          position: relative;
        }
      }
      .contact1-button:hover {
        background-color: #2a358e;
        color: #fff;
      }
    }
    .contact1-right {
      width: 50%;
      .con-img {
        margin-top: 67px;
        widows: 720px;
        height: 570px;
      }
      .contact1-form {
        padding: 82px 50px 80px 50px;
        background: #f7f8fa;
        h3 {
          margin-bottom: 44px;
          margin-top: 0;
          font-size: 40px;
          font-family: Arial-Bold, Arial;
          font-weight: bold;
          color: #2a2e2e;
        }
        /deep/.el-textarea__inner {
          font-family: "" !important;
        }
        /deep/.el-button {
          font-weight: bold;
          color: #ffffff;
          padding: 11px 47px;
          background: #2a358e;
          border: none;
        }
      }
    }
  }
  .contact2-content {
    margin-bottom: 100px;
    padding: 50px 5px;
    display: flex;
    .map {
      width: 1059px;
      height: 620px;
      position: relative;
      .area1 {
        position: absolute;
        top: 173px;
        left: 430px;
      }
      .area2 {
        position: absolute;
        top: 204px;
        left: 446px;
      }
      .area3 {
        position: absolute;
        top: 235px;
        left: 457px;
      }

      .area4 {
        position: absolute;
        top: 424px;
        left: 356px;
      }

      .red-point {
        width: 12px;
        height: 12px;
        background: #ff0000;
        border-radius: 50%;
      }
      .red-point::before,
      .red-point::after {
        position: absolute;
        width: 12px;
        left: 0;
        height: 12px;
        background-color: rgba(255, 0, 0, 0.2);
        border-radius: 50%;
        content: "";
      }
      .red-point::before {
        -webkit-animation: scaleout 2s infinite;
        animation: scaleout 2s infinite;
      }
      @keyframes scaleout {
        0% {
          transform: scale(1);
          opacity: 1;
        }

        100% {
          transform: scale(4);
          opacity: 0;
        }
      }

      @-webkit-keyframes scaleout {
        0% {
          transform: scale(1);
          opacity: 1;
        }

        100% {
          transform: scale(4);
          opacity: 0;
        }
      }
      img {
        width: 100%;
        height: 100%;
      }
    }
    .where {
      padding: 203px 26px;
      width: 25%;
      text-align: left;
      h3 {
        padding-bottom: 40px;
        opacity: 0;
        font-size: 40px;
        font-family: Arial-Bold, Arial;
        font-weight: bold;
        color: #2a2e2e;
        border-bottom: 1px solid #dee0e3;
      }
      p {
        font-size: 16px;
        opacity: 0;
        font-family: Microsoft YaHei UI-Regular, Microsoft YaHei UI;
        font-weight: 400;
        color: #2a2e2e;
        line-height: 30px;
      }
    }
  }
  .contact3-content {
    margin: 0 auto;
    width: 1440px;
    padding: 0 0 60px 0;
    .content-top {
      opacity: 0;
      width: 100%;
      display: flex;
      text-align: left;
      padding-bottom: 30px;
      border-bottom: 1px solid #2a2e2e;
      div {
        width: 33.33333333%;
        font-size: 20px;
        font-family: Microsoft YaHei UI-Bold, Microsoft YaHei UI;
        font-weight: bold;
        color: #2a358e;
      }
    }
    .content-bottom {
      width: 100%;
      display: flex;
      .second {
        width: 33.33333%;
      }
    }

    .card {
      width: 90%;
      opacity: 0;
      text-align: left;
      margin-bottom: 40px;
      h1 {
        font-size: 18px;
        font-family: Arial-Bold, Arial;
        font-weight: bold;
        color: #2a2e2e;
        margin: 20px 0;
      }
      p {
        margin: 10px 0;
        font-size: 14px;
        font-family: Arial-Regular, Arial;
        font-weight: 400;
        color: #2a2e2e;
        line-height: 21px;
      }
    }
  }
}
</style>